import * as React from 'react';
import { SectionNotificationContext } from './types';

const context = React.createContext<SectionNotificationContext>({
  type: 'default',
});

export const SectionNotificationProvider = context.Provider;
export const SectionNotificationConsumer = context.Consumer;
